export const DEFAULT_SORT_BY = 'createdAt'

export const DEFAULT_SORT_DIRECTION = 'desc'

export const IMAGE_EXTENSIONS = [
	'jpg',
	'jpeg',
	'png',
	'webp',
	'avif',
	'gif',
]

export const DEFAULT_ACCEPT = {
	'image/jpeg': ['.jpg', '.jpeg'],
	'image/png': ['.png'],
	'image/gif': ['.gif'],
	'image/webp': ['.webp'],
	'application/pdf': ['.pdf'],
	'application/msword': ['.doc', '.dot'],
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
		['.docx', '.docm', '.dotx', '.dotm'],
	'application/rtf': ['.rtf'],
}

export const ROWS_PER_PAGE_OPTIONS = [20, 40, 60, 80]
